import { render, staticRenderFns } from "./test-group.vue?vue&type=template&id=4b515775&"
import script from "./test-group.vue?vue&type=script&lang=js&"
export * from "./test-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports